import BaseModel from '../../models/BaseModel';
import Api from '../../services/Api';
import PasswordService from '../../services/PasswordService';

export default class ResetPasswordModel extends BaseModel {

    getSubmitUrl() {
        return 'member/password_reset/confirm';
    }
    /**
     * Get validation rules
     */
    getValidationRules() {
      return {
        password: {
          presence: {
            allowEmpty: false,
            message: '^Please enter password'
          }
        },
        repeatedPassword: {
          presence: {
            allowEmpty: false,
            message: '^Please repeat the password'
          },
          equality: {
            attribute: "password",
            message: "Passwords don't match"
          }
        }
      }
    }

    customValidation(record) {
      try {
        PasswordService.validatePassword(record.password);
      } catch(e) {
        return [
          {
            field: 'password',
            message: e.message
          }
        ];
      }

      return [];
    }



    static async checkHash(hash) {
      let response = await Api.call(
        'member/password_reset/check',
        {
          hash
        }
      );

      return response.success;
    }
}



// WEBPACK FOOTER //
// ./src/common/script/models/security/ResetPasswordModel.js